"use client"

import { useState } from "react"
import { apiClient } from "../services/apiClient"
import { useAuth } from "../contexts/AuthContext"
import { useLanguage } from "../contexts/LanguageContext"

export function ChangePasswordModal({ isOpen, onClose, isRequired = false }) {
  const { t } = useLanguage()
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const { refreshUser } = useAuth()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setSuccess("")

    if (newPassword.length < 6) {
      setError(t("password.minError"))
      return
    }

    if (newPassword !== confirmPassword) {
      setError(t("password.mismatch"))
      return
    }

    setIsLoading(true)

    try {
      await apiClient.changePassword(newPassword)
      setSuccess(t("password.success"))
      await refreshUser()

      setTimeout(() => {
        onClose()
        setNewPassword("")
        setConfirmPassword("")
        setSuccess("")
      }, 1500)
    } catch (err) {
      setError(err.message || t("password.error"))
    } finally {
      setIsLoading(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="text-xl font-semibold mb-4">{t("password.change")}</h2>
        <p className="text-gray-600 mb-6">{isRequired ? t("password.required") : t("password.enter")}</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="label" htmlFor="newPassword">
              {t("password.new")}
            </label>
            <input
              id="newPassword"
              type="password"
              className="input"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder={t("password.minLength")}
              required
            />
          </div>
          <div>
            <label className="label" htmlFor="confirmPassword">
              {t("password.confirm")}
            </label>
            <input
              id="confirmPassword"
              type="password"
              className="input"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder={t("password.repeat")}
              required
            />
          </div>
          {error && <div className="alert alert-error">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}
          <div className="flex space-x-2">
            <button type="submit" className="btn btn-primary flex-1" disabled={isLoading}>
              {isLoading && <span className="loading-spinner"></span>}
              {isLoading ? t("password.saving") : t("password.change")}
            </button>
            {!isRequired && (
              <button type="button" className="btn btn-outline" onClick={onClose}>
                {t("common.cancel")}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  )
}
